<script>
export default {
  name: "responsiveImage",
  props: {
    src: {
      type: String,
      required: true,
    },
    breakpoints: {
      type: Array,
      default: () => [
        `(min-width: 375px) and (max-width: 767px)`,
        `(min-width: 768px) and (max-width: 991px)`,
        `(min-width: 992px) and (max-width: 1199px)`,
        `(min-width: 1200px)`,
      ],
    },
    sizes: {
      type: Array,
      default: () => [`100vw`],
    },
    srcset: {
      type: Array,
      default: () => [`1500`, `1000`, `500`, `300`],
    },
  },
  methods: {
    getSrcset() {
      const srcStr = this.src;
      const splitSrc = srcStr.split(/v\d{5,12}/);
      return this.srcset
        .map((imgSize, i) => {
          return `${splitSrc[0]}f_auto/q_auto/w_${this.srcset[i]}${splitSrc[1]} ${this.srcset[i]}w`;
        })
        .join(", ");
    },
  },
};
</script>

<template>
  <img
    :sizes="
      `(min-width: 375px) and (max-width: 767px) ${sizes[0]},
              min-width: 768px) and (max-width: 991px) ${sizes[0]},
              (min-width: 992px) and (max-width: 1199px) ${sizes[0]},
              (min-width: 1200px) ${sizes[0]},${sizes[0]}`
    "
    :srcset="getSrcset()"
    :src="src"
    class="heroImg  fullBleedMob"
  />
</template>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppResponsiveImage.vue